<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员中心</router-link></li>
                <li class="currentNode"><a>上传专报信息</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>上传专报信息</h3>
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <el-form-item label="标题" prop="name">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="上传附件" prop="other">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                multiple
                                :limit="1"
                                :on-exceed="handleExceed"
                                :on-success="uploadSuccess"
                                :file-list="fileList"
                                list-type="picture">
                                <el-button size="small" style="width:350px;border-radius:0;"><i class="el-icon-upload"></i>点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">注:每上传 1 条专报信息，可任意下载 5 条专报信息</div>
                                </el-upload>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    baseUrl,
    addJiaoliu,
    editJiaoliu
} from '@services/tokenService.js';
import {
    getProjectDetail
} from '@services/indexService.js';
import rulesPattern from '@/assets/utils/rulesPattern.js';
import { getCookie } from '@/assets/utils/cookie.js';
export default {
    name:"",
    components: { PersonCenterMenu },
    data() {
        return {
            editId: null,
            uploadUrl: `${baseUrl}/api/ZhuJingBanXieHui/UploadFile`,
            fileList: [],
            form:{
                name: "",
                other: "",
            },
            rules: {
                name: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                other: [
                    { required: true, message: '请上传附件', trigger: 'blur' },
                ]
            }
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        // 鉴权
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        }
        // 编辑
        if(this.$route.query.id) {
            this.editId = this.$route.query.id;
            this.getProjectDetail();
        } 
    },
    methods: {
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.editId !== null && this.editId !== '') {
                        this.editJiaoliu();
                    } else {
                        this.addJiaoliu();
                    }
                } else {
                    return false;
                }
            });
        },
        addJiaoliu() {
            let param = {
                Name: this.form.name,
                Invest: "专报信息", // 写死
                Other: this.form.other, // 附件地址
                AccountId: this.accountId, // 提交人用户id
                ProjectName: getCookie('loginName'), // 提交人姓名
                CompanyName: getCookie('companyName'), // 所属协会名称
                CompanyDesc: getCookie('companyId') // 所属协会id
            };
            addJiaoliu(param).then(res => {
                if (res.Code == 1) {
                    this.$message.success("专报信息保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        editJiaoliu() {
            let param = {
                ProjectId: this.editId,
                Name: this.form.name,
                Invest: "专报信息", // 写死
                Other: this.form.other, // 附件地址
                AccountId: this.accountId, // 提交人用户id
                ProjectName: getCookie('loginName'), // 提交人姓名
                CompanyName: getCookie('companyName'), // 所属协会名称
                CompanyDesc: getCookie('companyId') // 所属协会id
            };
            editJiaoliu(param).then(res => {
                if (res.Code == 1) {
                    this.$message.success("专报信息保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        uploadSuccess( response, file, fileList) {
            let url = response.data.url;
            this.fileList.push({
                name: file.name,
                url: url
            })
            this.form.other = url;
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleRemove(file, fileList) {
            // 去删除的文件
            this.fileList = this.fileList.filter(item => item.url !== file.url);
            this.form.other = '';
        },
        handlePreview(file) {
            console.log(file);
        },
        getProjectDetail() {
            let params = {
                id: this.editId,
                accountid: this.accountId,
            };
            getProjectDetail(params).then(res => {
                // console.log(res);
                if (res.Code === 1) {
                    this.form.name = res.Data.Name;
                    let fileArr = res.Data.Other.split("/");
                    this.fileList = [{
                        name: fileArr[fileArr.length - 1],
                        url: res.Data.Other
                    }];
                    this.form.other = res.Data.Other;
                } else {
                    this.$message.error("专报详情请求失败");
                }
            })
        }
    },
}
</script>

<style scoped>
.page-content {
    padding: 30px;
    min-height: 750px;
}
.page-content h3{
    text-align:center;
    margin-bottom: 20px;
}
.form{
    width: 450px;
    margin: 0 auto;
}
.el-select {
    width: 350px;
}
.vertical-nav li a.active {
    border-left: none;
}
.el-upload .el-button:focus, 
.el-upload .el-button:hover{
    background-color: #ecf5ff;
    color: #116EBA; 
}
/* .el-button--small{
    font-size: 16px;
} */
</style>